<template>
   <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Barcode
      </v-card-title>
      <v-card-text class="text-xs-center">
       <canvas id="barcode"></canvas>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
  data: () => ({
    dialog: false,
    barcode: null
  }),

  methods: {
    open (imei) {
      console.log('open -> imei', imei);
      this.barcode = imei;
      JsBarcode('#barcode', imei);
      this.dialog = true;
    },

    close () {
      this.dialog = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/device/components/DialogShowBarcode.vue